import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "../../environments/environment";

@Injectable({
    providedIn: 'root'
})
export class DashboardTreeService {
    private readonly baseUrl = environment.apiUrl;

    constructor(private http: HttpClient) { }

    getCreateNewPartLookups(projectId: number): Observable<CreateNewPartLookups> {
        return this.http.get<CreateNewPartLookups>(`${this.baseUrl}/tree-node-operation/create-new-part/${projectId}`);
    }

    createNewProjectPart(request: CreateNewPartRequest): Observable<any> {
        return this.http.post(`${this.baseUrl}/tree-node-operation/create-new-part`, request);
    }

    trashProject(request: TrashProjectRequest): Observable<any> {
        return this.http.patch(`${this.baseUrl}/tree-node-operation/trash-project`, request);
    }

    getWellRedesignReport(wellId: number): Observable<WellRedesignReportResponse> {
        return this.http.get<WellRedesignReportResponse>(`${this.baseUrl}/tree-node-operation/generate-well-redesign-report/${wellId}`);
    }

    createNewProject(request: CreateNewProjectRequest): Observable<any> {
        return this.http.post(`${this.baseUrl}/tree-node-operation/create-new-project`, request);
    }

    searchWells(params: WellSearchParams): Observable<WellSearchResult[]> {
        const httpParams = new HttpParams({ fromObject: params as Record<string, string> });
        return this.http.get<WellSearchResult[]>(`${this.baseUrl}/tree-node-operation/wells-search`, { params: httpParams });
    }

    createCustomWell(request: CreateCustomWellRequest): Observable<CreateCustomWellResponse> {
        return this.http.post<CreateCustomWellResponse>(`${this.baseUrl}/tree-node-operation/create-well`, request);
    }
}

export interface CreateNewProjectRequest {
    //projectId: number;
    wellId: number;
    receivedDate: string;
    projectType: string | number;
    projectStatusId?: number;
    receivedBy: string;
    assignedToCAI: string;
    requestorCAI: string;
    alternateCustomers: string;
    expectedDueDate?: string;
    rigId?: number | null;
    rigName?: string;
    customerProvidedWBS: string;
    sap: string;
    isPayAsYouGo?: boolean;
    serviceCompanyId?: number | null;
    notes: string;
    mudTypeId: number;
    jobTypeId: number;
    jobSubTypeId: number;
    isBlendTest: boolean;
    riserless: boolean;
    measuredDepth?: number | null;
    totalVerticalDepth?: number | null;
    pipeSize: string;
    openHoleSize: string;
    bhct?: number | null;
    bhst?: number | null;
    mudWeightPerGallon?: number | null;
    waterDepth?: number | null;
}

export interface CreateNewPartLookupWell {
    id: number;
    name: string;
    buName: string;
    buCode: string;
    wellLocation: string;
}

export interface CreateNewPartLookupSlurry {
    slurryId: number;
    ufSlurryId: string;
    slurryTypeId: number;
}

export interface CreateNewPartLookupBusinessUnit {
    sbuCode: string;
    sbuName: string;
}

export interface CreateNewPartLookups {
    wells: CreateNewPartLookupWell[];
    slurries: CreateNewPartLookupSlurry[];
    businessUnits: CreateNewPartLookupBusinessUnit[];
    currentWellId: number;
}

export interface SlurryRedesignReason {
    reasonTypeId: number;
    comments: string;
    complianceTestIds: number[];
}

export interface ProjectRedesignReason {
    reasonTypeId: number;
    comments: string;
}

export interface CreateNewPartRequest {
    projectId: number;
    isDuplicate: boolean;
    duplicateSlurry: boolean;
    slurryToDuplicateId?: number;
    slurryIsRedesign?: boolean;
    slurryRedesignReason?: SlurryRedesignReason;
    projectRedesignReason?: ProjectRedesignReason;
    isExistingWell: boolean;
    existingWellId?: number;
    sbuCode?: string;
    wellLocation?: string;
    newWellName?: string;
}

export interface TrashProjectRequest {
    projectId: number;
    wellId: number;
}


export interface WellRedesignReportSlurry {
    slurryName: string;
    redesignReason: string;
    redesignComments: string | null;
    tests: string;
}

export interface WellRedesignReportProject {
    projectName: string;
    redesignReason: string;
    slurries: WellRedesignReportSlurry[];
}

export interface WellRedesignReportPipeSize {
    pipeSize: string;
    projects: WellRedesignReportProject[];
}

export interface WellRedesignReportWell {
    wellName: string;
    sbuCode: string;
    sbuName: string;
    pipeSizes: WellRedesignReportPipeSize[];
}

export interface WellSearchParams {
    WellName?: string;
    Api12?: string;
    ChevNo?: string;
    FieldName?: string;
    LeaseName?: string;
}

export interface WellSearchResult {
    cementWellId: number | null;
    wellName: string | null;
    wellLocation: string | null;
    api12: string | null;
    chevNo: string | null;
    fieldName: string | null;
    leaseName: string | null;
    sbuCode: string | null;
    country: string | null;
    operatorName: string | null;
}

export interface CreateCustomWellRequest {
    sbuCode: string;
    wellLocation?: string;
    wellName?: string;
    api12?: string | null;
    chevNo?: string | null;
    fieldName?: string | null;
    leaseName?: string | null;
    country?: string | null;
    operatorName?: string | null;
}

export interface CreateCustomWellResponse {
    wellId: number;
    wellName: string;
    sbuCode: string;
}

export interface WellRedesignReportResponse {
    wells: WellRedesignReportWell[];
}